import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ConversionSignalsIcon(props: IconProps) {
  return (
    <Icon width="72" height="73" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="36" cy="36.8071" r="36" fill="white" />
      <path
        d="M26.5927 47.2333C24.9357 46.0757 23.5808 44.5374 22.6418 42.7475C21.7028 40.9576 21.2071 38.9684 21.1964 36.9472C21.1858 34.926 21.6604 32.9317 22.5804 31.132C23.5005 29.3323 24.8391 27.7797 26.4837 26.6047"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <path
        d="M45.5019 26.3812C47.1588 27.5388 48.5138 29.0771 49.4528 30.867C50.3918 32.6569 50.8874 34.6461 50.8981 36.6673C50.9088 38.6885 50.4342 40.6828 49.5141 42.4825C48.5941 44.2822 47.2555 45.8348 45.6108 47.0098"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <path
        d="M20.8679 51.9392C16.8546 47.9259 14.6 42.4828 14.6 36.8071C14.6 31.1315 16.8546 25.6883 20.8679 21.675"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <path
        d="M51.2226 21.6752C55.2359 25.6884 57.4905 31.1316 57.4905 36.8073C57.4905 42.4829 55.2359 47.9261 51.2226 51.9393"
        stroke="#191A1C"
        strokeWidth="1.2"
      />
      <path
        d="M38.1174 39.0942L37.7454 38.6234C37.6757 38.6785 37.6128 38.7415 37.5577 38.8111C37.4942 38.8915 37.4469 38.9798 37.4117 39.0455C37.4084 39.0517 37.4052 39.0576 37.4021 39.0634L34.7062 44.0699C34.5738 44.316 34.4818 44.486 34.4075 44.6078C34.3582 44.4739 34.3009 44.2893 34.2187 44.0222L30.4767 31.8744C30.4102 31.6585 30.3658 31.5129 30.3385 31.4042C30.4472 31.4315 30.5927 31.4759 30.8086 31.5424L42.9565 35.2844C43.2235 35.3667 43.4081 35.424 43.542 35.4732C43.4202 35.5475 43.2502 35.6395 43.0042 35.772L37.9977 38.4678C37.9919 38.4709 37.9859 38.4741 37.9798 38.4774C37.9141 38.5126 37.8258 38.5599 37.7454 38.6234L38.1174 39.0942Z"
        fill="#57D7FF"
        stroke="#191A1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
